import { fromJS } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchEntries } from '@client/connectivity/api.cms';

export const EVENT_REDUCER_KEY = 'eventReducer';

const LOAD_EVENT_DATA = 'LOAD_EVENT_DATA';

let defaultState = fromJS({
  events: [],
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_EVENT_DATA: {
      return state.merge({
        events: fromJS(_cleanEventListing(action.payload)),
      });
    }
    default:
      return state;
  }
}

function _cleanEventListing(eventListing) {
  return eventListing.map((event) => {
    return event.fields;
  });
}

export function loadEvents() {
  return function (dispatch) {
    return fetchEntries('event').then((response) => {
      return dispatch({
        type: LOAD_EVENT_DATA,
        payload: response,
      });
    });
  };
}

export const selectEvents = (state) => {
  return getIn(state[EVENT_REDUCER_KEY], 'events');
};

export const selectEventBySlug = (state, slug) => {
  const allEvents = selectEvents(state);
  return (
    allEvents &&
    allEvents.find((event) => {
      return getIn(event, 'slug') === slug;
    })
  );
};

export const selectActiveEvents = (state) => {
  const allEvents = selectEvents(state);
  return (
    allEvents &&
    allEvents.filter((event) => {
      return getIn(event, 'currentlyActive');
    })
  );
};
